/**
 * 还没付掉的订单号，存在本地。
 *
 * **为什么要存**：支付这件事的真实节奏是"切出去付款 → 过几分钟回来"。
 * 只在收款面板开着的时候轮询的话，用户一关面板、或者压壳成 App 之后
 * 被系统挂起再回来，那笔到账就没人告诉他了 —— 他只会看到余额莫名其妙变了，
 * 或者更糟：以为没付成功，又付一次。
 *
 * 所以待付订单挂在 App 层（见 `usePaymentWatcher`），面板只是它的一个视图。
 */
const KEY = 'lobby.pendingOrders';
/** 最多记几笔。**不封顶的话，一串没付的单会一直攒着，每轮都去查一遍。** */
const MAX = 5;

export function listPending(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    const v = raw ? JSON.parse(raw) : [];
    return Array.isArray(v) ? v.filter((x) => typeof x === 'string').slice(0, MAX) : [];
  } catch {
    return [];          // 隐私模式下 localStorage 会抛。当成没有待付的单
  }
}

export function addPending(orderNo: string): void {
  if (!orderNo) return;
  const next = [orderNo, ...listPending().filter((x) => x !== orderNo)].slice(0, MAX);
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* 同上 */ }
}

export function dropPending(orderNo: string): void {
  const next = listPending().filter((x) => x !== orderNo);
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* 同上 */ }
}
